import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { CMSLanguageMenuItem, CMSMenuItem } from '../../cmsPage.state'
import { State } from '../../cmsPage.widget'
import { Drupal } from '../../drupal/api'
import { SearchBarState, searchBarStateZero } from '../../searchBar/searchBar.state'

export type CMSHeaderState = {
  isMenuOpen: boolean
  mainMenuItems: AsyncState<CMSMenuItem[]>
  topMenuItems: AsyncState<CMSMenuItem[]>
  openChildrenMenuItems: 'on-click' | 'on-hover'
  searchState: SearchBarState
  availableLanguages: AsyncState<CMSLanguageMenuItem[]>
  displayType: DisplayType
}

export const initCMSHeaderState = ():CMSHeaderState => ({
  isMenuOpen: false,
  mainMenuItems: loadingAsyncState(() => Drupal.getMainMenu("en", "")),
  topMenuItems: loadingAsyncState(() => Drupal.getTopMenu("en")),
  availableLanguages: loadingAsyncState(() => Drupal.getLanguages()),
  openChildrenMenuItems: "on-click",
  searchState: searchBarStateZero(),
  displayType: getDisplaySize()  
})

export type DisplayType = 'desktop' | 'mobile'
export const getDisplaySize = (): DisplayType => window.innerWidth >= 1024 ? 'desktop' : 'mobile'

export const CMSSiteHeaderUpdaters = {
  changeDisplayType: (currentState: State): State => ({
    ...currentState,
    CMSHeaderState: {
      ...currentState.CMSHeaderState,
      displayType: getDisplaySize(),
    },
    CMSFooterState: {
      ...currentState.CMSFooterState,
      displayType: getDisplaySize(),
    },
  }),
  toggleHeader: (currentState: State): State => ({
    ...currentState,
    CMSHeaderState: {
      ...currentState.CMSHeaderState,
      isMenuOpen: !currentState.CMSHeaderState.isMenuOpen,
      searchState: {
        ...currentState.CMSHeaderState.searchState,
        show: currentState.CMSHeaderState.isMenuOpen ? currentState.CMSHeaderState.searchState.show : false
      },
    },
  }),
  closeHeader: (currentState: State): State => ({
    ...currentState,
    CMSHeaderState: {
      ...currentState.CMSHeaderState,
      isMenuOpen: false,
    },
  }),
  toggleDropdownItem: (currentState: State, id: number, showChildren: boolean): State => ({
    ...currentState,
    CMSHeaderState: {
      ...currentState.CMSHeaderState,
      searchState: { ...currentState.CMSHeaderState.searchState, show: false },
      mainMenuItems:
        currentState.CMSHeaderState.mainMenuItems.kind == 'loaded'
          ? {
              ...currentState.CMSHeaderState.mainMenuItems,
              value: currentState.CMSHeaderState.mainMenuItems.value.map((item, index) =>
                index == id ? { ...item, ShowChildren: showChildren } : item
              ),
            }
          : currentState.CMSHeaderState.mainMenuItems,
    },
  }),
  closeDropdownItems: (currentState: State): State => ({
    ...currentState,
    CMSHeaderState: {
      ...currentState.CMSHeaderState,
      searchState: { ...currentState.CMSHeaderState.searchState, show: false },
      mainMenuItems:
        currentState.CMSHeaderState.mainMenuItems.kind == 'loaded'
          ? {
              ...currentState.CMSHeaderState.mainMenuItems,
              value: currentState.CMSHeaderState.mainMenuItems.value.map((item) => ({ ...item, ShowChildren: false })),
            }
          : currentState.CMSHeaderState.mainMenuItems,
    },
  }),
}
